import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import PrimaryButton from "../../PrimaryButton";
import { useAuth } from "../../auth/AuthContext";
import Footer from "../../pages/home/Footer";

const DonationsPage = () => {
  const { sendMails, getData } = useAuth();
  const [background, setBackground] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const responseClints = await getData("proccess.php", "projects_V2"); // Fetch adverts data
        if (responseClints.success) {
          setClients(responseClints.data);
        } else {
          console.error(
            responseClints.message || "Failed to load adverts data"
          );
        }

        const response = await getData("proccess.php", "backgrounds");
        if (response.success) {
          const contactbg = response.data.find(
            (bg) => bg.page_name === "donation"
          );
          if (contactbg) {
            setBackground(contactbg);
          }
        }
      } catch (error) {
        setErrors({ general: error.message });
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [getData]);

  return (
    <>
      <Box
        width={"100%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        paddingTop={"4rem"}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          minHeight={"70vh"}
          display={"flex"}
          flexWrap={"wrap"}
          justifyContent={"center"}
          alignItems={"center"}
          padding={"1rem"}
          gap={1}
          marginTop={"4rem"}
        >
          <Box
            flex={1}
            minWidth={"300px"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
          >
            <h1
              style={{ fontWeight: "700", textAlign: "center" }}
              className="primary-header"
            >
              Help fund and support our Vision & Mission
            </h1>
            <p style={{ textAlign: "justify", margin: "2rem 1rem" }}>
              To expand the reach and impact of our programmes, we welcome partnerships with government institutions, private sector organisations, foundations, and development partners. 
              Through collaboration, stakeholders can help strengthen youth education, support skills development, and contribute to building a future-ready generation.<br></br><br></br> Together, we can mobilise resources, share expertise, create meaningful learning opportunities, and drive innovation that benefits our communities. 
              By partnering with the Mindsinaction STEAM Centre, you become part of a collective effort to inspire young minds and help shape sustainable solutions for tomorrow.
            </p>
            <PrimaryButton
              bcolor="#d4e6f8ff"
              tittle="Contact Us"
              link={"/contact"}
            />
          </Box>
          <Box
            flex={1}
            minWidth={"300px"}
            maxWidth={"600px"}
            overflow={"hidden"}
            borderRadius={"2rem"}
          >
            {background ? (
              <img
                src={`https://mindsinaction.com.na/assets/media/pictures/${background.image}`}
                style={{ width: "100%" }}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>
      </Box>
      {/* Footer */}
      <Footer />
    </>
  );
};

export default DonationsPage;
